import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  display: flex;
  padding: 40px;
  min-height: 142px;
  border-radius: 12px;
  overflow: hidden;

  ${breakpoints.down('xs')} {
    padding: 24px 15px;
  }

  .banner-fmb {
    &__btn-wrap {
      display: flex;
      justify-content: flex-end;

      ${breakpoints.down('sm')} {
        justify-content: flex-start;
      }
    }

    &__btn {
      min-width: 197px;

      ${breakpoints.down('xs')} {
        width: 100%;
      }
    }
  }
`;

export default Container;
